import React, { useState } from 'react';

const SingleAnswer = ({ 
  questionNumber = "",
  question = "",
  answers = [],
  correctAnswer = 0,
  onCalculateScore
}) => {
  const [selectedAnswer, setSelectedAnswer] = useState(null); // Store the selected answer index

  const handleSelectAnswer = (index) => {
    const letter = String.fromCharCode(65 + index);
    setSelectedAnswer(index); // Save the selected index
    onCalculateScore(3, questionNumber, letter, correctAnswer);
  };

  return (
    <div className="w-full bg-white p-2 text-sm font-inter text-black">
      {/* Question Number */}
      <div className="px-3 py-1 w-full mb-1">
        <b>{questionNumber}.</b><span className="ml-2"></span>{question}
      </div>

      {/* Answer Choices */}
      <div className="ml-3 space-y-2">
        {answers.map((answer, index) => (
          <div 
            key={index}
            className={`flex items-center cursor-pointer p-2 rounded-md transition-colors ${
              selectedAnswer === index ? 'bg-blue-100' : ''
            }`}
            onClick={() => handleSelectAnswer(index)}
          >
            <div 
              className={`w-3 h-3 rounded-full border border-gray-400 flex items-center justify-center transition-all ${
                selectedAnswer === index ? 'bg-blue-400' : 'bg-white'
              }`}
            >
              {selectedAnswer === index && (
                <div className="w-1.5 h-1.5 bg-white rounded-full" />
              )}
            </div>
            <span className="ml-2">{answer}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SingleAnswer;
